import {
  DynamicField,
  ForeignKeyField,
  RemoteDataSource,
  Required,
  Schema,
  TextField
} from "lego-gui-lib";
import { mainStore } from "../../core/mainStore";
import { t } from "../../core/i18n/i18n";
import { set } from "lodash";
import { BooleanFieldWithBooleans } from "../../common/common";
import { Auth } from "../../core/model/auth";

export const ServiceProfileSchema = new Schema<DynamicField>({
  groups: {
    general: t("common:general"),
    routingType: t("hns:san:routingType"),
    blocks: t("hns:tree:treeBlock:block_plural"),
    features: t("common:features")
  },
  fields: [
    {
      name: "name",
      type: TextField(Required),
      group: "general"
    },
    //     // SAN routing types
    //
    //     private boolean routingTypeNoTranslation;       // SAN routing_type.NO_TRANSLATION
    {
      name: "config.routingTypeNoTranslation",
      title: t("hns:san:routingTypeEnum:noTranslation"),
      type: BooleanFieldWithBooleans(Required),
      group: "routingType"
    },
    //
    //     private boolean routingTypeTranslation;         // SAN routing_type.TRANSLATION
    {
      name: "config.routingTypeTranslation",
      title: t("hns:san:routingTypeEnum:translation"),
      type: BooleanFieldWithBooleans(Required),
      group: "routingType"
    },
    //
    //     private boolean routingTypeAnn;                 // SAN routing_type.ANNOUNCEMENT
    {
      name: "config.routingTypeAnn",
      title: t("hns:san:routingTypeEnum:announcement"),
      type: BooleanFieldWithBooleans(Required),
      group: "routingType"
    },
    //
    //     private boolean routingTypeTree;                // SAN routing_type.ROUTING_TREE
    {
      name: "config.routingTypeTree",
      title: t("hns:san:routingTypeEnum:routingTree"),
      type: BooleanFieldWithBooleans(Required),
      group: "routingType"
    },
    //
    //
    //
    //     // tree blocks available (for this SAN)
    //
    //     @JsonProperty("tBlockDestination")
    //     private boolean tBlockDestination;                // DESTINATION (D)
    {
      name: "config.tBlockDestination",
      title: t("hns:tree:treeBlock:destination"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //     @JsonProperty("tBlockERDestination")
    //     private boolean tBlockERDestination;                // EN_ROUTE_DESTINATION (ED
    {
      name: "config.tBlockERDestination",
      title: t("hns:tree:treeBlock:enRouteDestination"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //     @JsonProperty("tBlockMessage")
    //     private boolean tBlockMessage;                    // MESSAGE (M)
    {
      name: "config.tBlockMessage",
      title: t("hns:tree:treeBlock:message"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //     @JsonProperty("tBlockERMessage")
    //     private boolean tBlockERMessage;                // EN_ROUTE_MESSAGE (EM)
    {
      name: "config.tBlockERMessage",
      title: t("hns:tree:treeBlock:enRouteMessage"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //     @JsonProperty("tBlockHuntingGroup")
    //     private boolean tBlockHuntingGroup;                // HUNTING_GROUP (HG)
    {
      name: "config.tBlockHuntingGroup",
      title: t("hns:tree:treeBlock:huntingGroup"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //     @JsonProperty("tBlockRelease")
    //     private boolean tBlockRelease;
    {
      name: "config.tBlockRelease",                         // RELEASE (R)
      title: t("hns:tree:treeBlock:releaseCall"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    {
      name: "config.tBlockReleasePro",                    // RELEASE_PRO (RP)
      title: t("hns:tree:treeBlock:releaseCallPro"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //     @JsonProperty("tBlockSubTree")
    //     private boolean tBlockSubTree;                    // SUB_TREE (ST)
    {
      name: "config.tBlockSubTree",
      title: t("hns:tree:treeBlock:subtree"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //     @JsonProperty("tBlockIvrMenu")
    //     private boolean tBlockIvrMenu;                    // IVR_MENU (IM)
    {
      name: "config.tBlockIvrMenu",
      title: t("hns:tree:treeBlock:ivrMenu"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //     @JsonProperty("tBlockDayOfWeek")
    //     private boolean tBlockDayOfWeek;                // DAY_OF_WEEK (DOW)
    {
      name: "config.tBlockDayOfWeek",
      title: t("hns:tree:treeBlock:dayOfWeek"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //     @JsonProperty("tBlockCalendarDayType")
    //     private boolean tBlockCalendarDayType;            // CALENDAR_DAY_TYPE (CDT)
    {
      name: "config.tBlockCalendarDayType",
      title: t("hns:tree:treeBlock:calendarDayType"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //     @JsonProperty("tBlockTimeOfDay")
    //     private boolean tBlockTimeOfDay;                // TIME_OF_DAY (TOD)
    {
      name: "config.tBlockTimeOfDay",
      title: t("hns:tree:treeBlock:timeOfDay"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //     @JsonProperty("tBlockNumericCode")
    //     private boolean tBlockNumericCode;                // NUMERIC_CODE (NC)
    {
      name: "config.tBlockNumericCode",
      title: t("hns:tree:treeBlock:numericCode"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //     @JsonProperty("tBlockStandardIvr")
    //     private boolean tBlockStandardIvr;                // STANDARD_IVR (SI)
    {
      name: "config.tBlockStandardIvr",
      title: t("hns:tree:treeBlock:standardIvr"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //     @JsonProperty("tBlockGeographicGroup")
    //     private boolean tBlockGeographicGroup;            // GEOGRAPHIC_GROUP (GG)
    {
      name: "config.tBlockGeographicGroup",
      title: t("hns:tree:treeBlock:geographicGroup"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //     @JsonProperty("tBlockTraffic")
    //     private boolean tBlockTraffic;                    // TRAFFIC (T)
    {
      name: "config.tBlockTraffic",
      title: t("hns:tree:treeBlock:trafficDistribution"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //     @JsonProperty("tBlockRegistrationCounter")
    //     private boolean tBlockRegistrationCounter;        // REGISTRATION_COUNTER (RC
    {
      name: "config.tBlockRegistrationCounter",
      title: t("hns:tree:treeBlock:registrationCounter"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //     @JsonProperty("tBlockPresentation")
    //     private boolean tBlockPresentation;                // PRESENTATION (P)
    {
      name: "config.tBlockPresentation",
      title: t("hns:tree:treeBlock:presentation"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //     @JsonProperty("tBlockAdvancedConditions")
    //     private boolean tBlockAdvancedConditions;        // ADVANCED_CONDITIONS (AC)
    {
      name: "config.tBlockAdvancedConditions",
      title: t("hns:tree:treeBlock:advancedConditions"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //     @JsonProperty("tBlockExtAppDestination")
    //     private boolean tBlockExtAppDestination;        // EXT_APP_DESTINATION (EAD)
    {
      name: "config.tBlockExtAppDestination",
      title: t("hns:tree:treeBlock:extAppDestination"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //     @JsonProperty("tBlockExtAppBranch")
    //     private boolean tBlockExtAppBranch;                // EXT_APP_BRANCH (EAB)
    {
      name: "config.tBlockExtAppBranch",
      title: t("hns:tree:treeBlock:extAppBranch"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //     @JsonProperty("tBlockInputDestination")
    //     private boolean tBlockInputDestination;            // INPUT_DESTINATION(ID)
    {
      name: "config.tBlockInputDestination",
      title: t("hns:tree:treeBlock:inputDestination"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //     @JsonProperty("tBlockNetworkOperator")
    //     private boolean tBlockNetworkOperator;            // NETWORK_OPERATOR (NO)
    {
      name: "config.tBlockNetworkOperator",
      title: t("hns:tree:treeBlock:networkOperator"),
      type: BooleanFieldWithBooleans(Required),
      group: "blocks"
    },
    //
    //
    //
    //     // functionalities available (mostly set on SAN level)
    //
    //     private boolean featSanDeactivation;                // temporary SAN deactivation (3 fields on SAN: start, end, deactivation msg)
    {
      name: "config.featSanDeactivation",
      title: t("hns:serviceProfile:featSanDeactivation"),
      type: BooleanFieldWithBooleans(Required),
      group: "features"
    },
    //
    //     private boolean featUnIdentifiedCallersBlock;        // un-identified callers blocking (2 fields on SAN: unidentified...)
    {
      name: "config.featUnIdentifiedCallersBlock",
      title: t("hns:serviceProfile:featUnIdentifiedCallersBlock"),
      type: BooleanFieldWithBooleans(Required),
      group: "features"
    },
    //
    //     private boolean featScreenIn;                        // incoming screening (fields on SAN: screen_in_...)
    {
      name: "config.featScreenIn",
      title: t("hns:serviceProfile:featScreenIn"),
      type: BooleanFieldWithBooleans(Required),
      group: "features"
    },
    //
    //     private boolean featScreenOut;                        // outgoing screening (fields on SAN: screen_out_...)
    {
      name: "config.featScreenOut",
      title: t("hns:serviceProfile:featScreenOut"),
      type: BooleanFieldWithBooleans(Required),
      group: "features"
    },
    //
    //     private boolean featANumPortability;                // A-party number portability check  (SAN field: a_number_portability)
    {
      name: "config.featANumPortability",
      title: t("hns:serviceProfile:featANumPortability"),
      type: BooleanFieldWithBooleans(Required),
      group: "features"
    },
    //
    //     private boolean featMaxCallsSan;                        // max simultaneous calls per SAN (SAN field: max_calls)
    {
      name: "config.featMaxCallsSan",
      title: t("hns:serviceProfile:featMaxCallsSan"),
      type: BooleanFieldWithBooleans(Required),
      group: "features"
    },
    //
    //     private boolean featMaxCallDuration;                // max call duration (2 fields on SAN: max_duration...)
    {
      name: "config.featMaxCallDuration",
      title: t("hns:serviceProfile:featMaxCallDuration"),
      type: BooleanFieldWithBooleans(Required),
      group: "features"
    },
    //
    //     private boolean featInteractPriceAnn;                // price announcement (1 field on SAN: msg_price_ann_ref)
    {
      name: "config.featInteractPriceAnn",
      title: t("hns:serviceProfile:featInteractPriceAnn"),
      type: BooleanFieldWithBooleans(Required),
      group: "features"
    },
    //
    //     private boolean featInteractPin;                    // PIN access interaction (2 fields on SAN: pin, msg_pin_ref)
    {
      name: "config.featInteractPin",
      title: t("hns:serviceProfile:featInteractPin"),
      type: BooleanFieldWithBooleans(Required),
      group: "features"
    },
    //
    //     private boolean featInteractSelectLang;                // language selection (1 field on SAN: language_select_ref)
    {
      name: "config.featInteractSelectLang",
      title: t("hns:serviceProfile:featInteractSelectLang"),
      type: BooleanFieldWithBooleans(Required),
      group: "features"
    },
    //
    //     private boolean featInteractWelcomeAnn;                // welcome announcement (1 field on SAN: msg_welcome_ann_ref)
    {
      name: "config.featInteractWelcomeAnn",
      title: t("hns:serviceProfile:featInteractWelcomeAnn"),
      type: BooleanFieldWithBooleans(Required),
      group: "features"
    },
    //
    //     private boolean featSmsNotif;                        // possibility to send SMSes (2 fields on SAN: sms_notif...)
    {
      name: "config.featSmsNotif",
      title: t("hns:serviceProfile:featSMSNotif"),
      type: BooleanFieldWithBooleans(Required),
      group: "features"
    },
    //
    //     private boolean featCallHunting;                    // call hunting (not allowing view for hunting group manaagement)
    {
      name: "config.featCallHunting",
      title: t("hns:serviceProfile:featCallHunting"),
      type: BooleanFieldWithBooleans(Required),
      group: "features"
    },
    //
    //     private boolean featQueue;                            // call queueing (2 fieds on SAN: queue, we can block destination and hunting group queue configuration view)
    {
      name: "config.featQueue",
      title: t("hns:serviceProfile:featQueue"),
      type: BooleanFieldWithBooleans(Required),
      group: "features"
    },
    //
    //     private boolean featMaxCallsCPartyDest;                // C-party call limiter (allowing configuration on HNS destination objects for this SAN: field max_calls)
    {
      name: "config.featMaxCallsCPartyDest",
      title: t("hns:serviceProfile:featMaxCallsCPartyDest"),
      type: BooleanFieldWithBooleans(Required),
      group: "features"
    },
    //
    //     private boolean featCallLog;                        // call log (SAN flag call_log, also maybe view not available for call logs: nested view under SAN)
    {
      name: "config.featCallLog",
      title: t("hns:serviceProfile:featCallLog"),
      type: BooleanFieldWithBooleans(Required),
      group: "features"
    },
    //
    //     private boolean featReporting;                        // reporting (SAN flag reporting_active, also maybe view not available for reporting: nested view under SAN)
    {
      name: "config.featReporting",
      title: t("hns:serviceProfile:featReporting"),
      type: BooleanFieldWithBooleans(Required),
      group: "features"
    }
  ],
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ANYONE,
    editableRole: Auth.Roles.ADMIN
  }
});

mainStore.serviceProfile = RemoteDataSource.create({
  api: mainStore.api,
  commons: mainStore.commons,
  name: "serviceProfile",
  schema: ServiceProfileSchema,
  url: "/serviceProfiles"
});

mainStore.serviceProfileFK = RemoteDataSource.clone(mainStore.serviceProfile);

export const ServiceProfileFK = ForeignKeyField(
  {
    dataSource: mainStore.serviceProfileFK.listDataSource,
    labelField: "name",
    valueField: "id"
  },
  Required
);

export const DEFAULT_SERVICE_PROFILE = ServiceProfileSchema.fields.reduce(
  (acc, field) => {
    if (field.name !== "name") {
      set(acc, field.name, false);
    }

    return acc;
  },
  { config: {} } as any
);
